import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { firebaseAuth } from "../configs/firebase";

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v0/",
    prepareHeaders: async (headers) => {
      await firebaseAuth.authStateReady();
      const token = await firebaseAuth.currentUser?.getIdToken();
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});
